import { HelmetProvider } from 'react-helmet-async';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import './index.css';
import './toasts.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StoreProvider } from './Store';
import { LabelsProvider } from './context/LabelsContext';

const root = createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<StoreProvider>
			<LabelsProvider>
				<HelmetProvider>
					<App />
				</HelmetProvider>
			</LabelsProvider>
		</StoreProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
